import React from "react";
import DetailsTable from "../../../Table/DetailsTable";
import { CommandBarButton, IconButton, Stack } from "@fluentui/react";
import FeatureSummary from "../../../Util/FeatureSummary";
import { ActionItemLabel, useActionItemLabelLookups } from "./ActionItemLabel";

const buildChecklistColumn = (checklist) =>
  checklist.map((checklist) => checklist && checklist.name).join(", ");

const ActionItemsTable = ({
  actionItems,
  selectedActionItemId,
  setSelectedActionItemId,
  setSelectedActionItemTitle,
  cloneOnClick,
  refetch,
  loading,
  createOnClick,
  deleteOnClick,
  editOnClick,
  discoverOnClick,
}) => {
  const labelLookups = useActionItemLabelLookups();

  const columns = () => [
    {
      key: "column1",
      name: "ID",
      fieldName: "actionItemID",
      minWidth: 30,
      maxWidth: 30,
      isResizable: true,
    },
    {
      key: "column2",
      name: "Action Title",
      fieldName: "actionItemTitle",
      minWidth: 550,
      isResizable: true,
      onRender: (item) => (
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
          <div style={{ flex: 1, minWidth: 0 }}>
            <ActionItemLabel item={item.actionItem} lookups={labelLookups} />
          </div>
          <ContextualMenu
            editOnClick={editOnClick}
            cloneOnClick={cloneOnClick}
            deleteOnClick={deleteOnClick}
            discoverOnClick={discoverOnClick}
            id={item.actionItemID}
            title={item.actionItemTitle}
          />
        </Stack>
      ),
    },
    {
      key: "column3",
      name: "Primary Checklists",
      fieldName: "checklist",
      minWidth: 120,
      isResizable: true,
    },
    {
      key: "column4",
      name: "Action Type",
      fieldName: "actionItemType",
      minWidth: 150,
      isResizable: true,
    },
    {
      key: "column5",
      name: "Created Date",
      fieldName: "createdDate",
      minWidth: 200,
      isResizable: true,
    },
    {
      key: "column6",
      name: "Last Updated Date",
      fieldName: "lastUpdatedOn",
      minWidth: 200,
      isResizable: true,
    },
  ];

  const items = actionItems
    ? actionItems.map((actionItem) => ({
        actionItemID: actionItem.actionItemID,
        actionItemTitle: actionItem.actionItemTitle,
        checklist: buildChecklistColumn(actionItem.checklists),
        actionItemType: actionItem.actionItemType,
        createdDate: actionItem.createdDate,
        lastUpdatedOn: actionItem.lastUpdatedOn,
        actionItem,
      }))
    : [];

  const selectionHook = (items) => {
    const selectedItem = items && items[0];
    setSelectedActionItemId(selectedItem && selectedItem.actionItemID);
    setSelectedActionItemTitle?.(selectedItem?.actionItemTitle || "");
  };

  return (
    <>  
      <DetailsTable
        items={items}
        columns={columns()}
        selectionMode="none"
        selectionHook={selectionHook}
        loading={loading}
        mainColumn={"actionItemTitle"}
        style={{
          position: "relative",
          height: "80vh",
          width: "80vw",
        }}
        CommandBar={
          <>
            <CommandBarButton
              iconProps={{ iconName: "Add" }}
              text="Add Action Item"
              onClick={() => createOnClick()}
            />
          </>
        }
      />
      <FeatureSummary
        imageUrlPath='action-item-summary'
	      label="About Action Items"
        summary="This table displays all action items, including their title, associated checklists, type, and creation date. You can add, edit, clone, or delete action items. Action items are used to define tasks or steps for users to complete within a checklist."
      />
    </>
  );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
  editOnClick,
  cloneOnClick,
  deleteOnClick,
  discoverOnClick,
  id,
  title,
  ...rest
}) => {
  const menuProps = {
    items: [
      {
        key: "print",
        iconProps: { iconName: "Edit" },
        text: "Edit",
        onClick: () => editOnClick(id),
      },
      {
        key: "Delete",
        iconProps: { iconName: "Delete" },
        text: "Delete",
        onClick: () => deleteOnClick(id, title),
      },
      {
        key: "Clone",
        iconProps: { iconName: "Copy" },
        text: "Clone",
        onClick: () => cloneOnClick(id),
      },
      {
        key: "Discoverability",
        iconProps: { iconName: "Search" },
        text: "Discoverability",
        onClick: () => discoverOnClick(id),
      },
    ],
  };

  return (
    <IconButton
      iconProps={moreIcon}
      menuProps={menuProps}
      onRenderMenuIcon={() => {}}
      {...rest}
    />
  );
};

export default ActionItemsTable;
